var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    { staticClass: "cart-page__aside" },
    [
      _c("h6", [
        _vm._v(
          "\n    " +
            _vm._s(_vm.ordering ? "К оплате" : "Детали заказа") +
            "\n  "
        ),
      ]),
      _c("ul", { staticClass: "cart-page__aside-info" }, [
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cartItems.length,
                expression: "cartItems.length",
              },
            ],
          },
          [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm._f("plural")(
                    _vm.cartItems.length,
                    "товар",
                    "товара",
                    "товаров"
                  )
                )
              ),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.totalPriceWithoutDiscount) + " ₽")]),
          ]
        ),
        _c(
          "li",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.totalSale,
                expression: "totalSale",
              },
            ],
          },
          [
            _c("span", [_vm._v("Скидка")]),
            _c("span", [_vm._v("-" + _vm._s(_vm.totalSale) + " ₽")]),
          ]
        ),
      ]),
      _c("div", { staticClass: "cart-page__aside-sum" }, [
        _c("h6", [_vm._v("Итого")]),
        _c("h6", [_vm._v(_vm._s(_vm.totalPrice) + " ₽")]),
      ]),
      _vm.ordering
        ? [
            _c(
              "button",
              {
                staticClass: "btn btn--black cart-page__aside-action",
                on: {
                  click: function ($event) {
                    return _vm.$emit("order-create")
                  },
                },
              },
              [
                _vm.loading
                  ? _c("IconComponent", { attrs: { name: "loading" } })
                  : _c("span", [_vm._v(" Оформить заказ ")]),
              ],
              1
            ),
            _c("div", { staticClass: "cart-page__aside-politic" }, [
              _c(
                "span",
                [
                  _vm._v(
                    "\n        Нажимая на кнопку, вы соглашаетесь с\n        "
                  ),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { name: "about", params: { link: "termsOfUse" } },
                      },
                    },
                    [_vm._v("\n          условиями использования\n        ")]
                  ),
                  _vm._v("\n        и\n        "),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { name: "about", params: { link: "publicOffer" } },
                      },
                    },
                    [_vm._v("\n          публичной офертой\n        ")]
                  ),
                ],
                1
              ),
            ]),
          ]
        : [
            _c(
              "button",
              {
                staticClass: "btn btn--black cart-page__aside-action",
                attrs: { disabled: !_vm.cartItems.length },
                on: { click: _vm.toOrdering },
              },
              [_c("span", [_vm._v(" Оформить заказ ")])]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }